import React, { PureComponent } from 'react';

import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Col, Container, Row,
} from 'reactstrap';
import DataTable from '../../shared/components/DataTable';
import TooltipItem from '../../shared/components/TooltipItem';
import { fetchUsers, fetchFormDatas } from '../../redux/actions/usersActions';
import { deleteUser, resetUserPassword } from '../../redux/actions/userActions';
import Confirm from '../../shared/components/Confirm';
import { createErrorMessage, createSuccessMessage } from '../../helpers/notification';
import LoadingSpinner from '../../shared/components/LoadingSpinner';
import { dateFormat } from '../../helpers/dateFormat';

class UsersContainer extends PureComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  }

  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      pageSize: 25,
      totalItemsCount: 0,
      loading: true,
      items: [],
      filters: { id: 20 },
      roles: [],
    };

    this.columns = [
      { key: 'id', name: '#', width: '60px' },
      {
        key: 'numeroDocumento',
        name: 'Número de documento',
        search: true,
        type: 'number',
        width: '80px',
      },
      {
        key: 'roles',
        name: 'Roles',
        search: true,
        type: 'select',
        searchProps: {
          options: this.getRoles,
          isMulti: false,
        },
        width: '110px',
        format: (row) => {
          const { id, roles, categoriasProfesores } = row;

          return (
            <span style={{ display: 'flex' }}>
              {
                roles.map(rol => (
                  <button key={`${id}_${rol.value}`} type="button" className="action-button" tabIndex="-1">
                    <TooltipItem
                      id={`${id}_${rol.value}`}
                      value={rol.value}
                      label={rol.label}
                      key={`${id}_${rol.value}`}
                      color={this.getColor(rol.value)}
                    />
                  </button>
                ))
              }
              {
                roles.some(rol => rol.value === 'P') ? (
                  <button key={`${id}_categoriasProfesores`} type="button" className="action-button" tabIndex="-1">
                    <TooltipItem
                      id={`${id}_categoriasProfesores`}
                      value={`Escalafón: ${categoriasProfesores.length}`}
                      label={`${categoriasProfesores.length}`}
                      key={`${id}_${categoriasProfesores.length}`}
                      color={categoriasProfesores.length ? 'success' : 'secondary'}
                    />
                  </button>
                ) : null
              }
            </span>
          );
        },
      },
      { key: 'nombre', name: 'Nombre', search: true },
      { key: 'apellido', name: 'Apellido', search: true },
      { key: 'email', name: 'Email', search: true },
      { key: 'domicilioTelefono', name: 'Teléfono Celular', search: true },
      {
        key: 'arancelCero',
        name: 'Arancel Cero',
        search: true,
        format: ({ id, arancelCero, fechaFinArancelCero }) => (
          <TooltipItem
            tabIndex="-1"
            id={`${id}_${arancelCero}`}
            value={arancelCero ? 'Si' : 'No'}
            label={arancelCero ? `Fin arancel: ${dateFormat(fechaFinArancelCero)}` : ''}
            key={`${id}_${arancelCero}`}
            color={arancelCero ? 'success' : 'secondary'}
          />
        ),
      },
      { key: 'actions', name: 'Accion', width: '105px' },
    ];
    this.actions = [
      {
        key: 'edit',
        icon: <span className="fa fa-edit" title="Editar usuario" />,
        callback: (user) => {
          this.editUser(user);
        },
      },
      {
        key: 'reset_password',
        icon: <span className="fa fa-undo" title="Restablecer contraseña" />,
        callback: (user) => {
          this.resetUserPassword(user);
        },
      },
      {
        key: 'delete',
        icon: <span className="fa fa-trash disabled" title="Borrar usuario" />,
        /* callback: (user) => {
          this.deleteUser(user);
        },
        */
      },
    ];
  }

  componentDidMount() {
    this.fetchDatasList();

    const { page, pageSize } = this.state;
    this.updateUserTable(page, pageSize);
  }

  fetchDatasList = () => {
    fetchFormDatas({
      onSuccess: (d) => {
        this.setState({
          roles: d.roles,
        });
      },
      onError: () => {
        createErrorMessage('Error al intentar cargar los datos requeridos');
      },
    });
  }

  updateUserTable = (page, pageSize, filters = { roles: [] }) => {
    this.setState({
      loading: true,
      page,
      pageSize,
      filters,
    });
    console.log(filters.roles);
    fetchUsers({
      pageInfo: {
        page,
        pageSize,
        filters: {
          ...filters,
          roles: filters.roles && filters.roles.value ? [filters.roles.value] : [],
        },
      },
      onSuccess: (pageInfo) => {
        this.setState({
          loading: false,
          items: pageInfo.items,
          totalItemsCount: pageInfo.totalItemsCount,
        });
      },
      onError: () => {
        this.setState({ items: [], loading: false });
        createErrorMessage('Error al intentar cargar la lista de usuarios');
      },
    });
  }

  deleteUser = (user) => {
    const userName = `${user.nombre} ${user.apellido}`;
    Confirm({
      title: 'Borrar usuario',
      question: `Estás seguro que deseas eliminar a ${userName}?`,
      yesLabel: 'Si, Borrar usuario',
      noLabel: 'No, Volver',
      onConfirm: () => {
        deleteUser(user.id, {
          onSuccess: () => {
            createSuccessMessage('Usuario borrado exitosamente');
            const { page, pageSize } = this.state;
            this.updateUserTable(page, pageSize);
          },
          onError: (error) => {
            if (error && error.status === 404) {
              createErrorMessage('El usuario no existe');
            } else {
              createErrorMessage('Error al intentar borrar el usuario');
            }
          },
        });
      },
    });
  };

  resetUserPassword = (user) => {
    const userName = `${user.nombre} ${user.apellido}`;
    Confirm({
      title: 'Restablecer contraseña',
      question: `Estás seguro que deseas restablecer la contraseña de ${userName}?`,
      yesLabel: 'Si, Restablecer',
      noLabel: 'No, Volver',
      onConfirm: () => {
        resetUserPassword(user.email, {
          onSuccess: () => {
            const msg = 'Contraseña restablecida exitosamente. Se ha enviado un correo con la contraseña temporal.';
            createSuccessMessage(msg);
          },
          onError: (error) => {
            if (error && error.status === 404) {
              createErrorMessage('El usuario no existe');
            } else {
              createErrorMessage('Error al intentar restablecer contraseña');
            }
          },
        });
      },
    });
  };

  editUser = (user) => {
    const { history } = this.props;
    history.push(`/pages/users/edit/${user.id}`);
  };

  onChangePage = (page) => {
    if (page) {
      const { pageSize, filters } = this.state;
      this.updateUserTable(page, pageSize, filters);
    }
  };

  onDataTableSubmit = (values) => {
    if (values) {
      const { pageSize } = this.state;
      this.updateUserTable(1, pageSize, values);
    }
  };

  onDataTableClearFilters = () => {
    const { pageSize } = this.state;
    this.updateUserTable(1, pageSize, {});
  };

  getGridActions = (key) => {
    const actions = {
      actions: this.actions,
    };
    return actions[key];
  }

  getRoles = () => {
    const { roles } = this.state;
    return roles;
  };

  getColor = (value) => {
    const colors = [
      {
        value: 'A', color: 'info',
      },
      {
        value: 'P', color: 'success',
      },
      {
        value: 'F', color: 'primary',
      },
      {
        value: 'S', color: 'warning',
      },
    ];

    const { color } = colors.find(c => c.value === value);

    return color;
  };

  render() {
    const {
      loading,
      items,
      page,
      pageSize,
      totalItemsCount,
      filters,
    } = this.state;

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">Usuarios del Sistema</h3>
            <div className="card__title">
              <Link className="btn btn-primary" to="/pages/users/new">
                <i className="fa fa-plus" /> Agregar nuevo usuario
              </Link>
            </div>
          </Col>
        </Row>
        <Row>
          {loading
            ? <Col md={12}><LoadingSpinner /></Col>
            : (
              <DataTable
                title="Listado de todos los usuarios del sistema"
                columns={this.columns}
                items={items}
                onChangePage={this.onChangePage}
                page={page}
                pageSize={pageSize}
                totalItemsCount={totalItemsCount}
                getGridActions={key => this.getGridActions(key)}
                onSubmit={this.onDataTableSubmit}
                onClearFilters={this.onDataTableClearFilters}
                initialValues={filters}
                enableReinitialize
              />
            )
          }
        </Row>
      </Container>
    );
  }
}

export default withRouter(UsersContainer);
